import { useTheme } from '@mui/material';

export const RequiredAsterisk = () => {
  const theme = useTheme();
  const asteriskColor = theme.palette.error.main;
  return <span style={{ color: asteriskColor }}>*</span>;
};
